import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';

import { theme } from '@spa/shared/theme';
import ArrowLeft from '@spa/shared/svg/arrow-left';
import ArrowRight from '@spa/shared/svg/arrow-right';
import { Header, Carousel, Wrapper, ButtonsWrapper, CarouselWrapper } from './styles';

const SimpleCarousel = ({ children, title, numberOfElements, itemWidth, gap }) => {
  const { t } = useTranslation();
  const wrapperRef = useRef();
  const [activeIndex, setActiveIndex] = useState(0);
  const [elementsVisible, setElementsVisible] = useState(0);

  const goLeft = () => setActiveIndex(activeIndex - 1);
  const goRight = () => setActiveIndex(activeIndex + 1);

  const maxIndex = Math.ceil(numberOfElements - elementsVisible - 1);
  const carouselOffset = activeIndex * (itemWidth + gap);

  useEffect(() => setElementsVisible(wrapperRef?.current?.clientWidth / (itemWidth + gap)), []);

  return (
    <Wrapper ref={wrapperRef}>
      <Header>
        <p>{t(title)}</p>
        {numberOfElements > Math.round(elementsVisible) ? (
          <ButtonsWrapper leftEnabled={activeIndex > 0} rightEnabled={activeIndex < maxIndex}>
            <span>
              {activeIndex + 1}/{maxIndex + 1}
            </span>
            <div>
              <button className="left" onClick={goLeft}>
                <ArrowLeft color={theme.simpleCarousel.navigationControls.svgColor} />
              </button>
              <button className="right" onClick={goRight}>
                <ArrowRight color={theme.simpleCarousel.navigationControls.svgColor} />
              </button>
            </div>
          </ButtonsWrapper>
        ) : null}
      </Header>
      <CarouselWrapper>
        <Carousel carouselOffset={carouselOffset}>{children}</Carousel>
      </CarouselWrapper>
    </Wrapper>
  );
};

SimpleCarousel.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  numberOfElements: PropTypes.number.isRequired,
  itemWidth: PropTypes.number.isRequired,
  gap: PropTypes.number.isRequired
};

export default SimpleCarousel;
